import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref5, inView5] = useInView({ triggerOnce: true, threshold: 0.1 });

  const values = [
    {
      icon: 'ri-star-line',
      title: 'Kalite',
      content: 'Üretimden teslimat sürecine kadar her aşamada en yüksek kalite standartlarını korumak',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenilirlik',
      content: 'Müşterilerimize verdiğimiz sözleri tutmak ve uzun vadeli güven ilişkileri kurmak',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sürdürülebilirlik',
      content: 'Çevre dostu üretim anlayışı ile gelecek nesillere yaşanabilir bir dünya bırakmak',
    },
  ];

  const avatars = [
    'https://public.readdy.ai/ai/img_res/c1a8ddca46f4a17cb2ad41106e17c66b.jpg',
    'https://readdy.ai/api/search-image?query=advanced%20plastic%20injection%20molding%20machine%20in%20clean%20factory%20environment%20industrial%20machinery%20close%20up%20professional%20photography&width=160&height=160&seq=avatar-machine-001&orientation=squarish',
    'https://readdy.ai/api/search-image?query=clear%20transparent%20PET%20bottles%20and%20jars%20product%20lineup%20on%20white%20background%20professional%20product%20photography&width=160&height=160&seq=avatar-product-001&orientation=squarish',
    'https://readdy.ai/api/search-image?query=professional%20factory%20workers%20team%20in%20clean%20industrial%20environment%20wearing%20safety%20equipment%20modern%20manufacturing%20facility&width=160&height=160&seq=avatar-team-001&orientation=squarish',
  ];

  const timeline = [
    { year: '2018', title: 'Kuruluş', description: 'AnadoluPet, Anadolu Pet Ambalaj bünyesinde üç yıl önce kurulmuştur.' },
    { year: '2020', title: 'Teknoloji', description: 'Modern üretim teknolojileri ve otomatik üretim hatları ile üretim kapasitesi 4.000+ adet ürün/gün olarak artmıştır.' },
    { year: '2022', title: 'Sürdürülebilirlik', description: 'Sürdürülebilir üretim anlayışı ve çevre dostu çözümlerle sektörde fark yaratmaya başlanmıştır.' },
  ];

  const team = [
    { icon: 'ri-user-2-line', role: 'Müşteri Hizmetleri', count: '15+' },
    { icon: 'ri-user-3-line', role: 'Üretim', count: '30+' },
    { icon: 'ri-user-4-line', role: 'Pazarlama', count: '10+' },
    { icon: 'ri-user-5-line', role: 'Teknik Destek', count: '8+' },
    { icon: 'ri-user-6-line', role: 'Yönetim', count: '5+' },
  ];

  return (
    <div className="min-h-screen bg-white font-poppins">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[50vh] sm:min-h-[60vh] lg:min-h-[80vh] flex items-center justify-center overflow-hidden pt-16 sm:pt-20">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20team%20of%20engineers%20and%20workers%20in%20modern%20PET%20plastic%20packaging%20factory%20standing%20together%20confident%20smiling%20diverse%20team%20portrait%20industrial%20facility%20bright%20clean%20environment%20teal%20and%20white%20tones%20corporate%20team%20photography%20premium%20quality%20manufacturing%20company&width=1920&height=1080&seq=about-hero-team-factory-2025&orientation=landscape"
            alt="AnadoluPet Hakkında"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-navy/90 via-navy/80 to-navy/90" />
        </div>

        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto py-12 sm:py-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-6 sm:mb-8"
          >
            <span className="inline-block px-4 sm:px-6 py-2 bg-green/20 border border-green/30 rounded-full text-green text-xs sm:text-sm font-semibold uppercase tracking-wider backdrop-blur-sm">
              Hakkımızda
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 sm:mb-6"
          >
            Kaliteli Ambalaj Üretiminde<br className="hidden sm:block" />
            Güvenilir Partner
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-base sm:text-lg lg:text-xl text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-4"
          >
            Anadolu Pet Ambalaj olarak, yılların deneyimi ve modern teknoloji ile PET ambalaj sektöründe öncü konumdayız.
          </motion.p>
        </div>
      </section>

      {/* Company Info Section */}
      <section ref={ref1} className="py-12 sm:py-16 lg:py-28 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={inView1 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
              className="order-2 lg:order-1"
            >
              <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">/KİMİZ</span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-4 sm:mt-6 mb-6 sm:mb-8">
                Anadolu Pet Ambalaj
              </h2>
              <div className="space-y-4 sm:space-y-6 text-gray-600 text-sm sm:text-base leading-relaxed">
                <p>
                  <strong className="text-navy">Anadolu Pet Ambalaj</strong> PET ambalaj sektöründe kaliteli, güvenilir ve sürdürülebilir çözümler sunmak amacıyla kurulmuştur. Kurulduğumuz günden bu yana odağımız; yalnızca üretim yapmak değil, iş ortaklarımıza uzun vadeli değer sağlayan çözümler geliştirmek olmuştur.
                </p>
                <p>
                  Üretim tesisimizde, CNC kalıp atölyemiz dahil olmak üzere tüm süreçler kendi bünyemizde yürütülmektedir. Bu entegre yapı sayesinde; tasarımdan seri üretime kadar her aşama kontrol altında tutulur, müşteri taleplerine hızlı ve esnek şekilde yanıt verilir.
                </p>
                <p>
                  Anadolupet olarak, gıda temasına uygun hammaddeler, yüksek kalite standartları ve titiz kalite kontrol süreçleri ile üretim gerçekleştiriyoruz. Ürünlerimiz; gıda, içecek, temizlik, kozmetik ve endüstriyel kullanım alanlarında güvenle tercih edilmektedir. Yerli üretim gücümüz, teknik altyapımız ve deneyimli ekibimizle; yalnızca bugünün değil, geleceğin ambalaj ihtiyaçlarına da çözüm üretmeyi hedefliyoruz. Anadolupet için ambalaj, markaların güvenle taşıdığı bir sorumluluktur.
                </p>
              </div>

              <div className="flex items-center gap-4 mt-8">
                <a
                  href="https://www.instagram.com/anadolupetambalaj"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal to-green rounded-lg text-white text-xl hover:scale-110 hover:shadow-lg transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-instagram-line" />
                </a>
                <a
                  href="https://www.facebook.com/anadolupetambalaj"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal to-green rounded-lg text-white text-xl hover:scale-110 hover:shadow-lg transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-facebook-fill" />
                </a>
                <a
                  href="https://www.linkedin.com/company/anadolupetambalaj"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal to-green rounded-lg text-white text-xl hover:scale-110 hover:shadow-lg transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-linkedin-fill" />
                </a>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={inView1 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
              className="relative order-1 lg:order-2"
            >
              <div className="relative rounded-2xl lg:rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=artistic%20conceptual%20image%20showing%20transparent%20PET%20plastic%20bottle%20transforming%20into%20green%20nature%20elements%20with%20leaves%20plants%20and%20trees%20emerging%20from%20bottle%20sustainable%20recycling%20concept%20clean%20white%20background%20professional%20environmental%20photography%20hopeful%20ecological%20transformation&width=700&height=600&seq=about-sustainability-transform-001&orientation=landscape"
                  alt="Sürdürülebilirlik ve Doğa"
                  className="w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover"
                />
              </div>
              <div className="absolute -bottom-6 sm:-bottom-8 -right-6 sm:-right-8 w-48 h-48 sm:w-64 sm:h-64 bg-gradient-to-br from-green/20 to-teal/20 rounded-full blur-3xl -z-10" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section ref={ref2} className="py-12 sm:py-16 lg:py-28 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView2 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16 lg:mb-20"
          >
            <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">/DEĞERLERİMİZ</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-4 sm:mt-6 mb-4 sm:mb-6">Temel Prensiplerimiz</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Başarımızın arkasındaki değerler ve ilkeler
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={inView2 ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white p-6 sm:p-8 lg:p-10 rounded-2xl lg:rounded-3xl shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 group cursor-pointer"
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 flex items-center justify-center bg-gradient-to-br from-teal to-green rounded-xl lg:rounded-2xl text-white text-2xl sm:text-3xl mb-4 sm:mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                  <i className={value.icon} />
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-navy mb-3 sm:mb-4">{value.title}</h3>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed">{value.content}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section ref={ref3} className="py-12 sm:py-16 lg:py-28 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView3 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16 lg:mb-20"
          >
            <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">/TARİHÇEMİZ</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-4 sm:mt-6 mb-4 sm:mb-6">Gelişim Yolculuğumuz</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Kurulduğumuz günden bugüne başarı hikayemiz
            </p>
          </motion.div>

          <div className="relative">
            <div className="absolute left-4 sm:left-8 lg:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-teal via-green to-teal" />
            
            <div className="space-y-8 sm:space-y-12 lg:space-y-16">
              {timeline.map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  animate={inView3 ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  className={`relative flex items-center ${
                    index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  } flex-col lg:gap-16`}
                >
                  <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'} mb-4 lg:mb-0`}>
                    <div className={`bg-white p-6 sm:p-8 rounded-2xl lg:rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 ${
                      index % 2 === 0 ? 'ml-12 sm:ml-16 lg:ml-0' : 'ml-12 sm:ml-16 lg:ml-0'
                    }`}>
                      <div className="text-2xl sm:text-3xl font-bold text-green mb-3 sm:mb-4">{item.year}</div>
                      <h4 className="text-lg sm:text-xl font-bold text-navy mb-2 sm:mb-3">{item.title}</h4>
                      <p className="text-gray-600 text-sm sm:text-base">{item.description}</p>
                    </div>
                  </div>

                  <div className="absolute left-4 sm:left-8 lg:left-1/2 lg:transform lg:-translate-x-1/2 w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 flex items-center justify-center bg-gradient-to-br from-teal to-green rounded-full text-white font-bold shadow-lg z-10 top-6 sm:top-8">
                    <i className="ri-checkbox-circle-fill text-base sm:text-lg lg:text-xl" />
                  </div>

                  <div className="flex-1 hidden lg:block" />
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section ref={ref4} className="py-12 sm:py-16 lg:py-28 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView4 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16 lg:mb-20"
          >
            <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">/EKİBİMİZ</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-4 sm:mt-6 mb-4 sm:mb-6">Uzman Kadromuz</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Deneyimli ve profesyonel ekibimizle hizmetinizdeyiz
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6 lg:gap-8">
            {team.map((member, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={inView4 ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center group"
              >
                <div className="bg-gradient-to-br from-gray-50 to-white p-4 sm:p-6 lg:p-8 rounded-2xl lg:rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 cursor-pointer">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 flex items-center justify-center bg-gradient-to-br from-teal to-green rounded-full text-white mx-auto mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${member.icon} text-xl sm:text-2xl lg:text-3xl`} />
                  </div>
                  <h4 className="text-sm sm:text-base lg:text-lg font-bold text-navy mb-1 sm:mb-2">{member.role}</h4>
                  <p className="text-gray-600 text-xs sm:text-sm">{member.count}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section ref={ref5} className="py-16 sm:py-20 lg:py-32 bg-gradient-to-br from-navy via-navy/95 to-navy relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-green rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView5 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
              Birlikte Çalışmaya Hazır mısınız?
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-8 sm:mb-12 max-w-2xl mx-auto px-4">
              Kaliteli ambalaj çözümleri için bugün bizimle iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
              <Link
                to="/contact"
                className="w-full sm:w-auto px-8 sm:px-10 lg:px-12 py-3 sm:py-4 bg-green text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-green-dark hover:shadow-2xl hover:transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                İletişime Geçin
              </Link>
              <Link
                to="/products"
                className="w-full sm:w-auto px-8 sm:px-10 lg:px-12 py-3 sm:py-4 bg-transparent border-2 border-white text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-white hover:text-navy hover:transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Ürünleri İnceleyin
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
